import { render } from "./SingleSignOn.vue?vue&type=template&id=9f56bf8c&scoped=true"
import script from "./SingleSignOn.vue?vue&type=script&lang=js"
export * from "./SingleSignOn.vue?vue&type=script&lang=js"

import "./SingleSignOn.vue?vue&type=style&index=0&id=9f56bf8c&lang=scss&scoped=true"

import exportComponent from "/Users/chris.bamford/Documents/GitHub/rb-redev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9f56bf8c"]])

export default __exports__